import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';
import { UserService } from './core/user.service';

@Injectable()

export class PositionService {
	public url: string = Global.url_seguros
	private _http = inject(HttpClient)

	getAll(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'positions', {headers: headers})

	}

	getByGroup(group: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'positions/' + group, {headers: headers})

	}

	getByYear(group: any, year: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'positions/' + group + '/' + year, {headers: headers})
	}

	getByType(group: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'positions/type/' + group, {headers: headers})

	}

	setCapital(form: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'positions/max-capital', form, {headers: headers})

	}

	createPosition(position: any): Observable<any> {
		let params = position;
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'positions', params, { headers: headers })
	}
	
	updatePosition(office: any): Observable<any> {
		let params = office

		let headers = new HttpHeaders().set('Content-Type','application/json; charset=utf-8')

		var resultado = this._http.patch(this.url + 'positions/' + params._id, params, {headers: headers})
		return resultado;
	}





}
